import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import injectReducer from 'store/injectReducer';
import {
	MAP_ZOOM_TYPE_INDEXES,
	IMapReducer,
	ILocation,
} from 'modules/admin-panel/pages/results/models';

import * as types from '../ActionTypes';

export const InitialMapReducer: IMapReducer = {
	matchedLocations: [],
	isLocationSearchForOffice: false,
	zoomTypeIndex: MAP_ZOOM_TYPE_INDEXES.worldZoom,
};

export default injectReducer(InitialMapReducer, {
	[types.GET_MATCHED_LOCATIONS.REQUEST]: requestActionHandler,
	[types.GET_MATCHED_LOCATIONS.FAILURE]: failureActionHandler,
	[types.GET_MATCHED_LOCATIONS.SUCCESS]: (
		state: IMapReducer,
		{ payload }: { payload: ILocation[] },
	): IMapReducer => ({
		...successActionHandler(state),
		matchedLocations: payload,
	}),

	[types.SET_ZOOM_TYPE_INDEX]: (
		state: IMapReducer,
		{ payload }: { payload: MAP_ZOOM_TYPE_INDEXES },
	): IMapReducer => ({
		...state,
		zoomTypeIndex: payload,
	}),

	[types.RESET_MATCHED_LOCATIONS]: (state: IMapReducer): IMapReducer => ({
		...state,
		matchedLocations: [],
	}),

	[types.SET_IS_LOCATION_SEARCH_FOR_OFFICE]: (
		state: IMapReducer,
	): IMapReducer => ({
		...state,
		isLocationSearchForOffice: true,
	}),

	[types.RESET_IS_LOCATION_SEARCH_FOR_OFFICE]: (
		state: IMapReducer,
	): IMapReducer => ({
		...state,
		isLocationSearchForOffice: false,
	}),

	[types.SET_IS_LOCATION_CHANGED]: (
		state: IMapReducer,
		{ payload }: { payload: boolean },
	): IMapReducer => ({
		...state,
		isLocationChanged: payload,
	}),
});
